import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import NumberField from 'modules/core/components/NumberField'
import SelectField from 'modules/core/components/SelectField'
import TextArea from 'modules/core/components/TextArea'
import { FormErrors } from 'modules/core/hooks/useForm'
import { fromCents, toCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import { OptionItem } from 'modules/finance/components/SpendingPolicies/Detail/SpendingPolicyRulesForm/ruleFormHelpers'

export interface EditRuleFormProps {
  parentRuleGroupId?: string
  companyId: string
  description?: string | null
  categoryId: string
  amount: string
  timeFrame: string
  currency: string
}

interface Props {
  updateFormValues: (identifier: keyof EditRuleFormProps, value: string) => void
  formValues: EditRuleFormProps
  timeFrameOptions: OptionItem[]
  errors: FormErrors<EditRuleFormProps>
}
export const EditRulesForm: React.FC<Props> = ({
  updateFormValues,
  formValues,
  timeFrameOptions,
  errors,
}) => {
  return (
    <Box gap="s8">
      <Box flexDirection="row" gap="s8">
        <NumberField
          mandatory
          indicator={formValues.currency}
          label={i18n.t('spending_policies.wizard.steps.limits.row.amount')}
          value={fromCents(parseFloat(formValues.amount ?? '0'))}
          onChange={(value) => {
            updateFormValues('amount', toCents(parseFloat(value?.toString() ?? '0')) + '')
          }}
          error={errors.amount}
          placeholder={i18n.t('spending_policies.wizard.steps.limits.row.amount')}
        />
        <SelectField
          label={i18n.t('spending_policies.wizard.steps.limits.row.timeframe')}
          mandatory
          options={timeFrameOptions}
          value={formValues.timeFrame}
          onChange={(value) => {
            updateFormValues('timeFrame', value)
          }}
          error={errors.timeFrame}
          defaultOption={{
            value: '',
            disabled: true,
            label: i18n.t('common.select_basic'),
          }}
        />
      </Box>

      <TextArea
        label={i18n.t('spending_policies.wizard.steps.limits.row.description')}
        value={formValues.description ?? ''}
        onChange={(value) => {
          updateFormValues('description', value)
        }}
        placeholder={i18n.t('spending_policies.details.limits.placeholder.description')}
        minRows={3}
      />
    </Box>
  )
}
